import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from './landing-page.component';
import { TranslocoModule } from '@jsverse/transloco';

const routes: Routes = [
  {
    path: 'lcc',
    component: LandingPageComponent,
    data: { title: 'global.title' },
  },
  {
    path: 'lca',
    component: LandingPageComponent,
    data: { title: 'global.title' },
  },

  {
    path: '',
    component: LandingPageComponent,
    data: { title: 'global.title' },
  },
  // Fallback when no prior route is matched
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslocoModule],
  exports: [RouterModule],
  providers: [],
})
export class LandingPageRoutingModule {}
